import React, { useState } from 'react';
import { useNavigate } from '@reach/router';
import styled, { css } from 'styled-components';
import { Menu, MenuItem, Formatted, Paragraph, Avatar } from '@agilytics/components';
import { useAgilyticsDispatch, useAgilyticsState } from '@agilytics/global-state';
import { clearLocalStorage } from '@agilytics/utils';
import { useCurrentUser } from '@agilytics/hooks';
import content from './content.json';
import DownArrow from './downArrow.svg';

const Actions = styled.nav`
  max-width: 250px;
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  & > button {
    text-align: left;
  }
  background: ${({ theme }) => theme.colors.accentFg};
  display: ${({ show }) => (show ? 'block' : 'none')};
  z-index: 10;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: ${({ theme }) => theme.spacingTriple};
  margin-right: ${({ theme }) => theme.spacingTriple};
`;

const linkStyle = css`
  background: none;
  color: ${({ theme }) => theme.colors.brand};
  border: none;
  padding: 0;
  font-family: ${({ theme }) => theme.fonts.main};
  font-size: ${({ theme }) => theme.fontSizes.paragraph};
  cursor: pointer;
  outline: inherit;
`;

const MenuText = styled.p`
  ${linkStyle}
`;

const ToggleButton = styled.button`
  ${linkStyle}
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledArrow = styled.img`
  margin-left: ${({ theme }) => theme.spacingBase};
  width: 12px;
  height: 12px;
`;

const StatusText = styled.div`
  padding: ${({ theme }) => theme.spacingTriple};
  padding-bottom: 0;
  padding-top: ${({ theme }) => theme.spacingBase};
`;

export default function UserActions(props) {
  const state = useAgilyticsState();
  const dispatch = useAgilyticsDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const user = useCurrentUser();

  if (!state.accessToken) {
    return null;
  }

  const logout = () => {
    toggleNav();
    clearLocalStorage();
    dispatch({ type: 'logout' });
    navigate('/', { replace: true });
  };

  const manageCookies = () => {
    toggleNav();
    document.scrollingElement.scrollTop = 0;
    dispatch({ type: 'showCookiePreferences' });
  };

  const getAvatarFromUser = user => {
    return (user && user.avatarUrls && user.avatarUrls['48x48']) || 'https://placehold.it/48';
  };
  const toggleNav = () => setShow(!show);

  const renderStatus = () => {
    if (!user || !user.displayName) {
      return <Formatted content={content.fallback} />;
    }

    return (
      <>
        <Formatted content={content.content} />
        <Paragraph>
          <b>{user.displayName}</b>
        </Paragraph>
      </>
    );
  };

  return (
    <Container>
      <ToggleButton onClick={toggleNav}>
        <Avatar imgSrc={getAvatarFromUser(user)} />
        <StyledArrow src={DownArrow} />
      </ToggleButton>
      <Actions show={show}>
        <Menu dropdown>
          <StatusText>{renderStatus()}</StatusText>
          <MenuItem onClick={logout}>
            <MenuText>{content.logoutText}</MenuText>
          </MenuItem>
          <MenuItem onClick={manageCookies}>
            <MenuText>{content.manageText}</MenuText>
          </MenuItem>
        </Menu>
      </Actions>
    </Container>
  );
}
